module.exports = __webpack_public_path__ + "img/2.35f6f3eb.jpg";